import { observer } from "mobx-react";
import { ApplicationFilterItemsStore } from "stores/ApplicationFilters/ApplicationFilterItemsStore";
import { useStore } from "utils/useStore";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import {
    chipAggregatedLabel,
    chipItemLabel,
    renderCollectionChips,
    useChipFiltersStore,
} from "../BaseChipComponents/chipUtils";

export const TopicsChips = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);
    const applicationFilterItemsStore = useStore(ApplicationFilterItemsStore);

    const topics = applicationFiltersStore.topics;
    const isExclusion = !applicationFiltersStore.containsTopics;
    const setTopicsAndNormalizeMode = (nextTopics: typeof topics) => {
        applicationFiltersStore.setTopics(nextTopics);
        if (isExclusion && nextTopics.length === 0)
            applicationFiltersStore.setContainsTopics(true);
    };

    // The chip label is a plain string and cannot carry a status tag, so the marker is what tells
    // these apart from the supported Theme filter's chips in ThemesChips. It is added only for
    // viewers who can see this filter's Deprecated status -- the others have no second Theme filter
    // to confuse these with. See ApplicationFilterItemsStore.withDeprecationMarker.
    const itemLabel = applicationFilterItemsStore.withDeprecationMarker(
        "topics",
        "Theme",
    );
    const aggregatedLabel = applicationFilterItemsStore.withDeprecationMarker(
        "topics",
        "Themes",
    );

    return renderCollectionChips({
        items: topics,
        disabled: props.disabled,
        isApplicable: props.isApplicable,
        getKey: (topic) => topic.id,
        getLabel: (topic) =>
            chipItemLabel(itemLabel, topic.topicLabel, isExclusion),
        getTooltipLabel: (topic) => topic.topicLabel,
        getAggregatedLabel: (count) =>
            chipAggregatedLabel(count, aggregatedLabel, isExclusion),
        onRemoveAll: () => setTopicsAndNormalizeMode([]),
        onRemoveItem: (topic) =>
            setTopicsAndNormalizeMode(
                applicationFiltersStore.topics.filter((t) => t.id !== topic.id),
            ),
    });
});
